if (!window.crypto) {
  // @ts-ignore
  window.crypto = window.msCrypto;
}
